import React from 'react';
import EntityForm from './EntityForm';

function ManageCompanyBankForm({ onChanged, selectedEntry = null, setSelectedEntry }) {
    return (
        <EntityForm
            noun="Company Bank"
            heading="Add New Company Bank"
            idKey="CompanyBankID"
            insertUrl="insert_manage_company_bank"
            updateUrl="update_manage_company_bank"
            deleteUrl="delete_manage_company_bank"
            fields={[
                { name: 'name', label: 'Company Bank Name', entryKey: 'Name', required: true },
                { name: 'address', label: 'Company Bank Address', entryKey: 'Address', type: 'textarea' },
                { name: 'account_no', label: 'Account Number', entryKey: 'AccountNo' },
                { name: 'swift_code', label: 'Swift Code', entryKey: 'SwiftCode' },
                { name: 'routing_no', label: 'Routing No.', entryKey: 'RoutingNo' },
            ]}
            selectedEntry={selectedEntry}
            setSelectedEntry={setSelectedEntry}
            onChanged={onChanged}
        />
    );
}

export default ManageCompanyBankForm;
